import { render, staticRenderFns } from "./ObjectDetailsTemplate.vue?vue&type=template&id=1efdb987"
import script from "./ObjectDetailsTemplate.vue?vue&type=script&lang=ts"
export * from "./ObjectDetailsTemplate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports